import { classNames } from "@ember-decorators/component";
import ComboBoxComponent from "select-kit/components/combo-box";
import HomepageStyleSelectorRow from "./homepage-style-selector/homepage-style-selector-row";
import { pluginApiIdentifiers } from "./select-kit";
const HomepageStyleSelector = dt7948.c(class HomepageStyleSelector extends ComboBoxComponent {
  modifyComponentForRow() {
    return HomepageStyleSelectorRow;
  }
}, [pluginApiIdentifiers(["homepage-style-selector"]), classNames("homepage-style-selector")]);
export default HomepageStyleSelector;